<template>
    <div class="Card" style="height: 100%;">
        <div class="Card__Head">
            <div class="Card__Head__Title_Wrapper" v-if="selectedPortfolioChart === 'market-value'">
                <div class="Card__Head__Title">{{ currencySign }}{{ getInvestmentNum.toLocaleString("fi-FI", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(',','.') }}</div>
                <div class="Card__Head__Subtitle">{{ $t('initial-investment') }} {{ currencySign }}{{ getInitialInvestmentNum.toLocaleString("fi-FI", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(',','.') }}</div>
                <div class="Card__Head__ChartPerformance">
                    <span class="performance-amount" :class="{ 'positive': getPerformanceAmount > 0, 'negative': getPerformanceAmount < 0}">{{ currencySign }}{{ getPerformanceAmount.toLocaleString("fi-FI", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(',','.') }}</span>
                    <span class="performance-rate" :class="{ 'positive': getPerformanceAmount > 0, 'negative': getPerformanceAmount < 0}">
                        <svg width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg" v-if="getPerformanceAmount > 0">
                            <path d="M4 0.75L0.25 4.5H7.75L4 0.75Z" fill="#018671"/>
                        </svg>
                        <svg width="8" height="5" viewBox="0 0 8 5" fill="none" xmlns="http://www.w3.org/2000/svg" v-else>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M0.25 0.5L4 4.25L7.75 0.5H0.25Z" fill="#D5394F"/>
                        </svg>
                        {{ getPerformanceRate }}%
                    </span>
                </div>
            </div>
            <div class="Card__Head__Title_Wrapper" v-if="selectedPortfolioChart === 'bottles-number'">
                <div class="Card__Head__Title">{{ getBottlesNum }} {{ $t('bottles') }}</div>
            </div>

            <div class="Card__Head__CTA" v-on:click="openPortfolioChartsModalHandler">
                <svg v-if="selectedPortfolioChart === 'market-value'" width="40" height="40" viewBox="0 0 40 40"
                     fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="40" height="40" rx="4" fill="black" fill-opacity="0.08"/>
                    <path d="M24 25.01V18H22V25.01H19L23 29L27 25.01H24ZM17 11L13 14.99H16V22H18V14.99H21L17 11Z"
                          fill="#004F7F"/>
                </svg>
                <svg v-if="selectedPortfolioChart === 'bottles-number'" width="40" height="40" viewBox="0 0 40 40"
                     fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="40" height="40" rx="4" fill="black" fill-opacity="0.08"/>
                    <path
                        d="M21 10H19V15C17.8333 15.319 17 16.1756 17 17.1839L17 29.4855C17 29.7685 17.2967 30 17.6667 30H22.3333C22.7 30 23 29.7685 23 29.4855V17.1839C23 16.1756 22.1634 15.319 21 15V10Z"
                        fill="#004F7F"/>
                </svg>
            </div>
        </div>
        <div class="Card__Content Market-Bottles-Charts">
            <div v-if="selectedPortfolioChart === 'market-value'">
                <div v-if="!isMarketValueChartLoading">
                    <MarketValue
                        v-bind:getMarketValuestArr="getMarketValuestArr"
                        v-bind:getMarketCalculationDateArr="getMarketCalculationDateArr"
                        v-bind:marketString="marketString"
                        v-bind:initialString="initialString"
                    ></MarketValue>
                    <DatePicker :selectedChart="selectedPortfolioChart" v-on:onMarketValueDatePick="onMarketValueDatePick"></DatePicker>
                </div>
            </div>
            <div v-if="selectedPortfolioChart === 'bottles-number'">
                <div v-if="!isBottlesChartLoading">
                    <Bottles
                        v-bind:getBottlesCountArr="getBottlesCountArr"
                        v-bind:getBottlesCalculationDateArr="getBottlesCalculationDateArr"
                        v-bind:bottlesString="bottlesString"
                    ></Bottles>
                    <DatePicker :selectedChart="selectedPortfolioChart"
                                v-on:onBottlesDatePick="onBottlesDatePick"></DatePicker>
                </div>
            </div>
        </div>

        <v-dialog v-model="openPortfolioChartsModal" max-width="496px">
            <v-card class="portfolio-charts-modal">
                <div class="close-modal" v-on:click="closePortfolioChartsModalHandler">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                              d="M11.6897 0.344433C12.1007 0.738147 12.1007 1.39508 11.6897 1.7888L7.29269 6.00022L11.6897 10.2116C12.1007 10.6053 12.1007 11.2623 11.6897 11.656L11.6201 11.7226C11.2337 12.0927 10.6243 12.0931 10.2375 11.7234L5.99898 7.67256L1.76047 11.7234C1.37362 12.0931 0.764287 12.0927 0.377845 11.7226L0.308296 11.656C-0.102765 11.2623 -0.102766 10.6053 0.308296 10.2116L4.70528 6.0002L0.308318 1.7888C-0.102744 1.39508 -0.102743 0.738147 0.308318 0.344433L0.377867 0.277819C0.764309 -0.0923146 1.37364 -0.0926466 1.76049 0.277066L5.999 4.32786L10.2375 0.277066C10.6244 -0.0926465 11.2337 -0.0923141 11.6201 0.277819L11.6897 0.344433Z"
                              fill="black" fill-opacity="0.64"/>
                    </svg>
                </div>
                <v-card-title>{{ $t('portfolio-charts') }}</v-card-title>

                <v-card-text class="portfolio-charts-modal-body">
                    <label for="one" class="portfolio-chart__row">
                        <div class="radio-button-wrapper">
                            <input type="radio" id="one" value="market-value" v-model="setSelectedPortfolioChart">
                        </div>
                        <div class="icon-wrapper">
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <rect width="40" height="40" rx="4" fill="black" fill-opacity="0.08"/>
                                <path
                                    d="M24 25.01V18H22V25.01H19L23 29L27 25.01H24ZM17 11L13 14.99H16V22H18V14.99H21L17 11Z"
                                    fill="#004F7F"/>
                            </svg>
                        </div>
                        <div class="content-wrapper">
                            <div class="title">{{ $t('market-value') }}</div>
                            <div class="sub-title">{{ $t('market-value-subtitle') }}</div>
                        </div>
                    </label>
                    <label for="two" class="portfolio-chart__row">
                        <div class="radio-button-wrapper">
                            <input type="radio" id="two" value="bottles-number" v-model="setSelectedPortfolioChart">
                        </div>
                        <div class="icon-wrapper">
                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <rect width="40" height="40" rx="4" fill="black" fill-opacity="0.08"/>
                                <path
                                    d="M21 10H19V15C17.8333 15.319 17 16.1756 17 17.1839L17 29.4855C17 29.7685 17.2967 30 17.6667 30H22.3333C22.7 30 23 29.7685 23 29.4855V17.1839C23 16.1756 22.1634 15.319 21 15V10Z"
                                    fill="#004F7F"/>
                            </svg>
                        </div>
                        <div class="content-wrapper">
                            <div class="title">{{ $t('number-of-bottles') }}</div>
                            <div class="sub-title">{{ $t('number-of-bottles-subtitle') }}</div>
                        </div>
                    </label>
                </v-card-text>

                <v-card-actions>
                    <v-btn class="btn-primary" v-on:click="closePortfolioChartsModalHandler">{{ $t('done') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import MarketValue from "./PortfolioCharts/MarketValue";
import Bottles from "./PortfolioCharts/Bottles";
import DatePicker from "./PortfolioCharts/DatePicker";
import {mapActions, mapGetters} from "vuex";
import {GCommon, GPerformance, GUser} from "@/store/getters";
import {APerformance, AUser} from "@/store/actions";
import moment from "moment";

export default {
    name: "InvestmentCharts",
    components: {
        MarketValue,
        DatePicker,
        Bottles
    },
    data() {
        return {
            selectedMarketValuePeriod: '',
            selectedPortfolioChart: '',
            setSelectedPortfolioChart: localStorage.getItem('portfolio-selected-chart') ? localStorage.getItem('portfolio-selected-chart') : 'market-value',
            openPortfolioChartsModal: false,
            isMarketValueChartLoading: true,
            isBottlesChartLoading: true,
            getInvestmentNum: 0,
            getInitialInvestmentNum: 0,
            getPerformanceAmount: 0,
            getPerformanceRate: 0,
            getMarketValuestArr: [],
            getMarketCalculationDateArr: [],
            getBottlesNum: 0,
            getBottlesCountArr: [],
            getBottlesCalculationDateArr: [],
            bottlesString: this.$i18n.t('bottles'),
            marketString: this.$i18n.t('market'),
            initialString: this.$i18n.t('initial'),
        }
    },
    computed: {
        ...mapGetters({
            currencySign: GCommon.GET_CURRENCY_SIGN,
            userData: GUser.GET_USER_DATA,
            marketValuesList: GPerformance.GET_MARKET_VALUES,
            bottlesList: GPerformance.GET_BOTTLES
        }),
    },
    methods: {
        ...mapActions({
            loadMarketValues: APerformance.LOAD_MARKET_VALUES,
            loadBottles: APerformance.LOAD_BOTTLES
        }),
        transformPeriodToDate(period = '1y') {
            let selectedPeriod = '';

            switch (period) {
                case '1m':
                    selectedPeriod = moment().subtract(30, 'days').calendar(null, {
                        sameElse: 'YYYY-MM-DD'
                    });
                    break;
                case '6m':
                    selectedPeriod = moment().subtract(182, 'days').calendar(null, {
                        sameElse: 'YYYY-MM-DD'
                    });
                    break;
                case '1y':
                    selectedPeriod = moment().subtract(1, 'year').calendar(null, {
                        sameElse: 'YYYY-MM-DD'
                    });
                    break;
                case 'all':
                    selectedPeriod = moment().subtract(5, 'years').calendar(null, {
                        sameElse: 'YYYY-MM-DD'
                    });
                    break;
                default:
                    selectedPeriod = moment().subtract(1, 'year').calendar(null, {
                        sameElse: 'YYYY-MM-DD'
                    });
            }

            return selectedPeriod
        },
        onMarketValueDatePick(period) {
            this.loadMarketValuesFunc(period);
        },
        onBottlesDatePick(period) {
            this.loadBottlesFunc(period);
        },
        openPortfolioChartsModalHandler() {
            this.openPortfolioChartsModal = true
        },
        closePortfolioChartsModalHandler() {
            this.selectedPortfolioChart = this.setSelectedPortfolioChart;
            localStorage.setItem('portfolio-selected-chart', this.setSelectedPortfolioChart);
            this.openPortfolioChartsModal = false;
        },
        loadMarketValuesFunc(period) {
            this.loadMarketValues({
                userId: this.userData.id,
                startDate: this.transformPeriodToDate(period)
            }).then(() => {
                this.getMarketValuestArr = []
                this.getMarketCalculationDateArr = []

                let marketValueArr = this.marketValuesList.map(item => {
                    return {
                        marketValue: parseFloat(String(item.marketValue).replaceAll(',', '').split('.')[0]),
                        marketValueFormatted: item.marketValue,
                        investmentAmount: item.investmentAmount,
                        performanceAmount: item.performanceAmount,
                        performanceRate: item.performanceRate
                    }
                })
                let calculationDate = this.marketValuesList.map(item => item.calculationDate)

                marketValueArr.map(item => this.getMarketValuestArr.push(item))
                calculationDate.map(item => this.getMarketCalculationDateArr.push(period === '1m' ? moment(item.split('T')[0]).locale(this.$i18n.locale).format('DD MMM') : moment(item.split('T')[0]).locale(this.$i18n.locale).format('MMM')))

                this.isMarketValueChartLoading = false;
                this.getInitialInvestmentNum = this.marketValuesList[this.marketValuesList.length - 1].investmentAmount
                this.getInvestmentNum = marketValueArr[marketValueArr.length - 1].marketValueFormatted
                this.getPerformanceAmount = this.marketValuesList[this.marketValuesList.length - 1].performanceAmount
                this.getPerformanceRate = this.marketValuesList[this.marketValuesList.length - 1].performanceRate
            });
        },
        loadBottlesFunc(period) {
            this.loadBottles({userId: this.userData.id, startDate: this.transformPeriodToDate(period)}).then(() => {
                this.getBottlesCountArr = [];
                this.getBottlesCalculationDateArr = [];

                let countOfBottlesOwnedArr = this.bottlesList.map(item => item.countOfBottlesOwned)
                let calculationDate = this.bottlesList.map(item => item.calculationDate)

                countOfBottlesOwnedArr.map(item => this.getBottlesCountArr.push(parseFloat(item.replaceAll(',', '').split('.')[0])))
                calculationDate.map(item => this.getBottlesCalculationDateArr.push(period === '1m' ? moment(item.split('T')[0]).locale(this.$i18n.locale).format('DD MMM') : moment(item.split('T')[0]).locale(this.$i18n.locale).format('MMM')))

                this.isBottlesChartLoading = false;
                this.getBottlesNum = countOfBottlesOwnedArr[countOfBottlesOwnedArr.length - 1]
            });
        }
    },
    mounted() {
        this.$nuxt.$on('langUpdated', () => {
            this.loadMarketValuesFunc(localStorage.getItem('selectedMarketValuePeriod'));
            this.loadBottlesFunc(localStorage.getItem('selectedBottlesPeriod'))
        })
    },
    created() {
        this.$store.dispatch(AUser.GET_USER_DATA).then(() => {
            this.loadMarketValuesFunc(localStorage.getItem('selectedMarketValuePeriod'));
            this.loadBottlesFunc(localStorage.getItem('selectedBottlesPeriod'))

            if (localStorage.getItem('portfolio-selected-chart') === null) {
                this.selectedPortfolioChart = 'market-value'
            } else {
                this.selectedPortfolioChart = localStorage.getItem('portfolio-selected-chart')
            }

        });
    }
}
</script>

<style>
.Card__Content.Market-Bottles-Charts .v-item-group.theme--light.v-slide-group {
    max-width: 100%;
    width: 100%;
    height: 32px;
    background: rgba(0, 0, 0, 0.04);
    border-radius: 4px;
}

.Card__Content.Market-Bottles-Charts .v-tab.v-tab--active {
    background-color: var(--white) !important;
    border-radius: 4px;
}
</style>

<style scoped>
.portfolio-charts-modal {
    padding: 40px 16px 16px;
}

.portfolio-charts-modal .close-modal {
    position: absolute;
    top: 20px;
    right: 20px;
    cursor: pointer;
}

.portfolio-charts-modal .v-card__title {
    font-family: Montserrat, sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 29px;
    margin-bottom: 16px;
    justify-content: center;
}

.portfolio-charts-modal .v-card__actions {
    justify-content: center;
    margin-bottom: 10px;
}

.portfolio-charts-modal .v-card__actions .btn-primary {
    background-color: var(--blue) !important;
    border-color: var(--blue);
    color: var(--white);
    max-width: 416px;
    width: 100%;
    border-radius: 8px;
}

.portfolio-charts-modal .portfolio-charts-modal-body {
    max-width: 416px;
    margin: 0 auto 40px;
    padding: 0;
}

.portfolio-charts-modal .portfolio-charts-modal-body .portfolio-chart__row + .portfolio-chart__row {
    margin-top: 16px;
}

.portfolio-charts-modal .portfolio-charts-modal-body .portfolio-chart__row {
    display: flex;
    align-items: center;
    padding: 16px;
    background: var(--white);
    border-radius: 8px;
    cursor: pointer;
}

.portfolio-charts-modal .portfolio-charts-modal-body .portfolio-chart__row .radio-button-wrapper + .icon-wrapper {
    margin-left: 16px;
}

.portfolio-charts-modal .portfolio-charts-modal-body .portfolio-chart__row .icon-wrapper + .content-wrapper {
    margin-left: 16px;
}

.portfolio-charts-modal .portfolio-charts-modal-body .portfolio-chart__row .content-wrapper .title {
    font-family: Montserrat, sans-serif !important;
    font-style: normal;
    font-weight: 600;
    font-size: 14px !important;
    line-height: 17px;
    color: rgba(0, 0, 0, 0.88);
}

.portfolio-charts-modal .portfolio-charts-modal-body .portfolio-chart__row .content-wrapper .sub-title {
    font-family: Montserrat, sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 17px;
    color: rgba(0, 0, 0, 0.88);
}
</style>
